export default function Index() {
    return (
        <>
            <div className="grid place-items-center h-screen bg-gray-100">a bizminer</div>
        </>
    )
}